// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__k6-qd","formControl":"addForm_formControl__gH+Rz","list":"addForm_list__t9GyH","btnWrpper":"addForm_btnWrpper__36VJI"};